import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {Image} from '../../model';
import {Gallery, GalleryRef} from '@ngx-gallery/core';
import {DOCUMENT} from '@angular/common';

@Component({
  selector: 'app-gallery',
  templateUrl: './user-gallery.component.html',
  styleUrls: ['./user-gallery.component.scss']
})
export class UserGalleryComponent implements OnInit {

  @Input() images: Image[];
  @Input() youtubes: string[];
  @Input() editable = false;
  @Output() remove: EventEmitter<{type: string, index: number}> = new EventEmitter();
  @Input() imageSize = 'cover';
  @Input() fullHeight = false;
  @Input() thumbs = true;
  @Input() fluid = false;
  galleryRef: GalleryRef;

  constructor(@Inject(DOCUMENT) private document, private gallery: Gallery) { }


  ngOnInit() {
    if (this.galleryRef) {
      this.galleryRef.reset();
    } else {
      this.galleryRef = this.gallery.ref('gallery');
    }
    if (this.images) {
      this.images.filter(img => img.url.toString().length > 0).map((img: Image) => {
        console.log('adding img', img);
        this.galleryRef.addImage({
          src: img.url,
          thumb: img.url
        });
      });
    }
    if (this.youtubes) {
      this.youtubes.filter(str => str.length > 0).map((src) => {
        console.log('youtube is ', src);
        this.galleryRef.addYoutube({src});
      });
    }
  }

  removeImage($event: MouseEvent, type: string, index: number) {
    $event.stopPropagation();
    console.log('removing ', type, index);
    this.remove.emit({type, index});
  }
}
